<template>
    <div class="navbar">
        <div class="navbox">
            <div class="nav hvr-wobble-bottom" v-for="(item, index) in NavList" :key="index" :class="url == item.path ? 'active_nav' : ''  " >
                <div class="iconbox">
                    <img :src="item.iconSrc" alt="">
                </div>
                <div class="name" @click="changePath( item )" v-if=" index == 0">
                    {{ item.name }}
                </div>
                <div class="name" v-else-if=" index == 1">
                    <el-dropdown @command="handleCommand" :hide-on-click="false" trigger="click">
                        <span class="el-dropdown-link" style="color:#fff;font-size:19px;">
                            {{ item.name }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" style="width:150px;">
                            <el-dropdown-item :command="beforeHandleCommand(item1.sCateId, item.cateId, index, item1.sCateName)" v-for="(item1, index) in cateList1" :key="index">{{ item1.sCateName }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
               <div class="name" v-else-if=" index == 2">
                    <el-dropdown @command="handleCommand" :hide-on-click="false" trigger="click">
                        <span class="el-dropdown-link" style="color:#fff;font-size:19px;">
                            {{ item.name }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" style="width:150px;">
                            <el-dropdown-item :command="beforeHandleCommand(item1.sCateId, item.cateId, index, item1.sCateName)" v-for="(item1, index) in cateList2" :key="index">{{ item1.sCateName }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                 <div class="name" v-else-if=" index == 3">
                    <el-dropdown @command="handleCommand" :hide-on-click="false" trigger="click">
                        <span class="el-dropdown-link" style="color:#fff;font-size:19px;">
                            {{ item.name }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" style="width:150px;">
                            <el-dropdown-item :command="beforeHandleCommand(item1.sCateId, item.cateId, index, item1.sCateName)" v-for="(item1, index) in cateList3" :key="index">{{ item1.sCateName }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                 <div class="name" v-else-if=" index == 4">
                    <el-dropdown @command="handleCommand" :hide-on-click="false" trigger="click">
                        <span class="el-dropdown-link" style="color:#fff;font-size:19px;">
                            {{ item.name }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" style="width:150px;">
                            <el-dropdown-item :command="beforeHandleCommand(item1.sCateId, item.cateId, index, item1.sCateName)" v-for="(item1, index) in cateList4" :key="index">{{ item1.sCateName }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                 <div class="name" v-else-if=" index == 5">
                    <el-dropdown @command="handleCommand" :hide-on-click="false" trigger="click">
                        <span class="el-dropdown-link" style="color:#fff;font-size:19px;">
                            {{ item.name }}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" style="width:150px;">
                            <el-dropdown-item :command="beforeHandleCommand(item1.sCateId, item.cateId, index, item1.sCateName)" v-for="(item1, index) in cateList5" :key="index">{{ item1.sCateName }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>

        <!-- <bai-du-map v-if="MapShow"></bai-du-map> -->
    </div>
</template>

<script>
    import BaiDuMap from "@/components/map/BaiDuMap"
    import Qs from "qs"
    export default {
        data() {
            return {
                NavList: [
                    { iconClass: "icon-shouye", name: "首页" , path: "/", iconSrc:require("../../assets/static/new/gonghui_ico01.png"),},
                    { iconClass: "icon-zixun", name: "工会概况", cateId: 258, iconSrc:require("../../assets/static/new/gonghui_ico02.png"), },
                    { iconClass: "icon-zuzhi-copy", name: "教工之家", cateId: 265, iconSrc:require("../../assets/static/new/gonghui_ico03.png"),},
                    { iconClass: "icon-dangjian", name: "女工园地" , cateId: 268, iconSrc:require("../../assets/static/new/gonghui_ico04.png"),},
                    { iconClass: "icon-zhuanti", name: "政策法规", cateId: 274, iconSrc:require("../../assets/static/new/gonghui_ico05.png"),},
                    { iconClass: "icon-wangluodangxiao", name: "党建工作", cateId: 279, iconSrc:require("../../assets/static/new/gonghui_ico06.png"), },
                    // { iconClass: "icon-fuwudating", name: "荣誉奖励", cateId: 7},
                    // { iconClass: "icon-ditu1", name: "交流之窗", cateId: 237}

                    // { iconClass: "icon-shouye", iconSrc:require("../../assets/static/new/gonghui_ico01.png"), name: "首页" , path: "/"},
                    // { iconClass: "icon-zixun", iconSrc:require("../../assets/static/new/gonghui_ico02.png"), name: "工会概况", cateId: 258 },
                    // { iconClass: "icon-zuzhi-copy", iconSrc:require("../../assets/static/new/gonghui_ico03.png"), name: "教工之家", cateId: 265},
                    // { iconClass: "icon-dangjian", iconSrc:require("../../assets/static/new/gonghui_ico04.png"), name: "女工园地" , cateId: 268},
                    // { iconClass: "icon-zhuanti", iconSrc:require("../../assets/static/new/gonghui_ico05.png"), name: "政策法规", cateId: 274},
                    // { iconClass: "icon-wangluodangxiao", iconSrc:require("../../assets/static/new/gonghui_ico06.png"), name: "党建工作", cateId: 279 },
                ], // 导航列表
                cateList1:[],
                cateList2:[],
                cateList3:[],
                cateList4:[],
                cateList5:[],
                MapShow: false,
                cateId: 2
            }
        },
        components: {
            BaiDuMap,
        },
        computed: {
            url() {
                return this.$route.path 
            }
        },
        mounted() {
            this.getAllCate()
        },
        methods : {
            //配置command的参数
            beforeHandleCommand(id,cateId,index,name){
                return {
                    'id':id,
                    'cateID':cateId,
                    'index': index,
                    'name': name
                }
            },
            // 跳转路由
            changePath ( item ) {
                if ( item.type && item.type == 'map') {
                    this.MapShow = true 
                } else {
                    this.$router.push( item.path )
                }
                
            },

            // 指令事件
            handleCommand ( command ) {
                this.$router.push(`/notify/${ command.id }/${ command.cateID }/${ command.index }/${ command.name }`)
            },
             // 获取全部二级分类
           async getAllCate() {
               let res1 = await this.$axios.post("/lencon/pc/news/allCates", Qs.stringify({cateId: 258}))
                if ( res1.data.code == 1 ) {
                    this.cateList1 = res1.data.newsCateList
                }
                let res2 = await this.$axios.post("/lencon/pc/news/allCates", Qs.stringify({cateId: 265}))
                if ( res2.data.code == 1 ) {
                    this.cateList2 = res2.data.newsCateList
                }
                let res3 = await this.$axios.post("/lencon/pc/news/allCates", Qs.stringify({cateId: 268}))
                if ( res3.data.code == 1 ) {
                    this.cateList3 = res3.data.newsCateList
                }
                let res4 = await this.$axios.post("/lencon/pc/news/allCates", Qs.stringify({cateId: 274}))
                if ( res4.data.code == 1 ) {
                    this.cateList4 = res4.data.newsCateList
                }
                let res5 = await this.$axios.post("/lencon/pc/news/allCates", Qs.stringify({cateId: 279}))
                if ( res5.data.code == 1 ) {
                    this.cateList5 = res5.data.newsCateList
                }
            },
        }
    }
</script>
<style>
 .el-dropdown-menu__item:hover {
    color: #2767c4  !important;
 }
</style>

<style lang="scss" scoped>
.navbar {
    min-width: 100%;
    height: 101px;
    box-sizing: border-box;
    overflow: hidden;
    margin-top: -25px;
    .navbox {
        width: 1200px;
        height: 101px;
        background: url("../../assets/static/new/gonghui_nav_middle.png") 0 0 no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        position: relative;
        &::after {
            max-width: 360px;
            width: 100%;
            height: 101px;
            content: "";
            background: url("../../assets/static/new/gonghui_nav_right.png") 0 0 no-repeat;
            background-size: 100% 100%;
            position: absolute;
            right: -360px;
            top: 0;
            z-index: 1;
        }
        &::before {
            max-width: 360px;
            width: 100%;
            height: 101px;
            content: "";
            background: url("../../assets/static/new/gonghui_nav_left.png") 0 0 no-repeat;
            background-size: 100% 100%;
            position: absolute;
            left: -360px;
            top: 0;
            z-index: 1;
        }
        .active_nav {
            flex: 1;
            .name{
                color: #FAE5AD;
                font-weight: bold;
            }
        }
        .nav {
            display: flex;
            flex: 1;
            color: #FFFFFF;
            font-size: 19px;
            line-height: 76px;
            height: 66px;
            padding-left: 10px;
            cursor: pointer;
            justify-content: center;
            .iconbox {
                margin-right: 5px;
                span {
                    font-size: 19px;
                    background: linear-gradient(0deg, #FDF9F6, #BED1FD);
                    background-clip: text;
                    color: transparent;
                }
                img{
                    width: 24px;
                    height: 24px;
                    margin-top: 25px;
                }
            }
        }
    }
}
</style>